<script lang="ts">
    import {enhance} from "$app/forms";
    import {Badge, Checkbox, Label, Toggle, Tooltip} from "flowbite-svelte";
    import dayjs from "dayjs";
    import relativeTime from "dayjs/plugin/relativeTime";
    import 'dayjs/locale/de'
    import type {Employee} from "$lib/types/employee";
    import CardLayout from "$items/CardLayout.svelte";
    import type {Writable} from "svelte/store";
    import {getContext} from "svelte";
    import {globalToast} from "$lib/stores/toast";
    import {post, put} from "$lib/api";
    import type {Reminder} from "$lib/types/reminders";

    const employee: Writable<Employee> = getContext('employee');
    const super_edit: Writable<Employee> = getContext('super_edit');

    dayjs.extend(relativeTime)
    dayjs.locale('de')

    let loading = false;
    let displayDoneReminders = false;
    let displayedReminders: Employee["reminders"] = [];
    let display = false;

    $: if (displayDoneReminders) {
        displayedReminders = $employee?.reminders?.filter((reminder) => {
            return reminder.doneAt?.value
        });
    } else {
        displayedReminders = $employee?.reminders?.filter((reminder) => {
            return !reminder.doneAt?.value
        });
    }
    const markAsDone = async (reminder: Reminder, checked: boolean) => {

        loading = true;
        const response = await put(`/employee/${$employee.uuid}/reminder/${reminder.id}`, { ...reminder, doneAt: checked ? '.' : null});
        $employee.reminders = [...$employee.reminders.filter((reminder) => reminder.id !== response.id), response];
        $globalToast.timed('Reminder erfolgreich geändert', 3000);
        loading = false;
    }
</script>

<CardLayout title="Erinnerungen" accordion bind:display>
    <svelte:fragment slot="card-header">
        <div class="flex gap-12">
            {#if display}
            <Toggle class="text-gray-500 dark:text-gray-400 w-[280px]" bind:checked={displayDoneReminders} size="small">
                Erledigte Erinnerungen {displayDoneReminders ? "ausblenden" : "anzeigen"}
            </Toggle>
            {/if}
            {#if displayedReminders && displayedReminders.length > 0}
                <Badge color="yellow">{displayedReminders.length}</Badge>
            {/if}
        </div>

    </svelte:fragment>
    {#if displayedReminders.length}

            <ul class="list-inside ml-2 list-disc space-y-2 text-neutral-600">
                {#each displayedReminders || [] as reminder}
                    <li class="flex flex-row gap-3">
                        <Checkbox type="checkbox"
                                  id="reminder-{reminder.uuid}"
                                  checked={!!reminder.doneAt?.value}
                                  on:change={(ev) => markAsDone(reminder, ev.target.checked)}
                                  class="w-4 h-4 text-blue-500 dark:text-blue-400" />
                        <span class="text-sm ">
                           {#if reminder.doneAt?.value}
                              {dayjs.unix(reminder.doneAt.stamp).fromNow()} erledigt:
                           {/if}
                        </span>
                        <div class="text-sm flex-1">
                            {@html reminder.note}
                        </div>
                        <span class="w-32 text-sm {dayjs.unix(reminder.remindAt.stamp).isBefore(dayjs()) ? 'text-red-500' : 'text-primary-700'}">
                            Fällig: {dayjs.unix(reminder.remindAt.stamp).fromNow()}

                        </span>
                        <Tooltip>{dayjs.unix(reminder.remindAt.stamp).format("DD.MM \@ HH:mm")}</Tooltip>
                    </li>
                {/each}
            </ul>
    {:else}
        <div class="flex flex-col space-y-2">
            <span class="text-sm text-gray-500">
                Keine Erinnerungen
            </span>
        </div>
    {/if}
</CardLayout>